import { log } from '@/log'

export type CarrierProvider =
  'docomo' |
  'au' |
  'softbank'

export function getCarrierProviderLabel(carrierProvider: CarrierProvider): string {
  switch (carrierProvider) {
    case 'docomo':
      return 'ドコモケータイ払い'
    case 'au':
      return 'auかんたん決済'
    case 'softbank':
      return 'ソフトバンクまとめて支払い'
    default:
      log.error(`invalid carrier_provider: ${carrierProvider}`)

      return ''
  }
}
